import React, { useState } from 'react';
import ContactForm from '../components/ContactForm';
import LocationPopup from '../components/LocationPopup';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const ContactPage: React.FC = () => {
  const [isMapOpen, setIsMapOpen] = useState(false);

  return (
    <>
      <div className="pt-32 pb-16 bg-black">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold text-gold text-center mb-8">Contact Us</h1>
          <p className="text-white text-center text-xl max-w-3xl mx-auto">
            Get in touch with our team for a free quote or to discuss your requirements
          </p>
        </div>
      </div>
      
      <section className="py-16 bg-black-light">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <ContactForm />
            </div>
            
            <div className="bg-black p-8 rounded-lg shadow-lg h-fit">
              <h3 className="text-gold font-bold text-2xl mb-6">Contact Information</h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <Phone className="text-gold mr-4 flex-shrink-0" size={24} />
                  <div className="flex-1 min-w-0">
                    <h4 className="text-gold font-semibold mb-1">Phone</h4>
                    <a 
                      href="tel:+447624222898" 
                      className="text-white hover:text-gold transition-colors block"
                    >
                      +44 7624 222898
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <Mail className="text-gold mr-4 flex-shrink-0" size={24} />
                  <div className="flex-1 min-w-0">
                    <h4 className="text-gold font-semibold mb-1">Email</h4>
                    <a 
                      href="mailto:siscaro.solutions@outlook.com"
                      className="text-white hover:text-gold transition-colors break-all block"
                    >
                      siscaro.solutions@outlook.com
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <MapPin className="text-gold mr-4 flex-shrink-0" size={24} />
                  <div className="flex-1 min-w-0">
                    <h4 className="text-gold font-semibold mb-1">Location</h4>
                    <button 
                      onClick={() => setIsMapOpen(true)}
                      className="text-white hover:text-gold transition-colors text-left block w-full"
                    >
                      Island Wide
                    </button>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 pt-8 border-t border-gold/30">
                <h4 className="text-gold font-semibold mb-3">Connect With Us</h4>
                <div className="space-y-3">
                  <a 
                    href="https://www.facebook.com/profile.php?id=61555453935419" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-white hover:text-gold transition-colors w-full"
                  >
                    <Facebook size={20} className="mr-2" />
                    <span>Follow us on Facebook</span>
                  </a>
                  <a 
                    href="https://www.instagram.com/SiscaroSolutions" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-white hover:text-gold transition-colors w-full"
                  >
                    <Instagram size={20} className="mr-2" />
                    <span>Follow us on Instagram</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <LocationPopup 
        isOpen={isMapOpen}
        onClose={() => setIsMapOpen(false)}
      />
    </>
  );
};

export default ContactPage;